var d = Object.defineProperty;
var D = (n, t, i) => t in n ? d(n, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : n[t] = i;
var r = (n, t, i) => D(n, typeof t != "symbol" ? t + "" : t, i);
import { UserLoginStatus as E } from "./main5.js";
const e = class e {
  /**
   * Retrieves or generates the user's Personally Identifiable Information (PII) lead data.
   *
   * @param leadFormData - The lead form data service for retrieving form data.
   * @param storage - The local storage service for managing stored user data.
   * @returns A partial `FormData` object containing the user's PII lead data.
   */
  static userPiiLead(t, i) {
    const a = e.getDefaultPiiLead(), s = i.getItem(
      e.LEAD_STORAGE_KEY
    ), L = t.get(), { email: c, name: u, formattedPhoneNumber: o } = L;
    let l = s || a;
    return (c || u || o) && (l = {
      email: c,
      name: u,
      phoneNumber: o
    }, i.setItem(
      e.LEAD_STORAGE_KEY,
      JSON.stringify(l)
    )), l;
  }
  static userPiiLocation(t, i) {
    const a = e.getDefaultPiiLocation(), s = i.getItem(
      e.LOCATION_STORAGE_KEY
    ), L = t.get(), { state: c, city: u } = L;
    let o = s || a;
    return (c || u) && (o = {
      state: c,
      city: u
    }, i.setItem(
      e.LOCATION_STORAGE_KEY,
      JSON.stringify(o)
    )), o;
  }
  /**
   * Transforms the user data into a structured format for use in other services.
   *
   * @param user - The current user object, or `null` if not logged in.
   * @param leadFormData - The lead form data service for retrieving form data.
   * @param storage - The local storage service for managing stored user data.
   * @returns A transformed user object.
   */
  static transform(t, i, a, s) {
    return {
      pii: {
        lead: e.userPiiLead(i, a),
        location: {
          optin: e.userPiiLocation(s, a)
        }
      },
      loginStatus: t ? E.LOGGED : E.LOGGED_OUT
    };
  }
  /**
   * Provides the default values for the user's PII lead data.
   *
   * @returns A partial `FormData` object with default values.
   */
  static getDefaultPiiLead() {
    return {
      email: void 0,
      name: void 0,
      phoneNumber: void 0
    };
  }
  /**
   * Provides the default values for the user's PII geolocation data.
   *
   * @returns A partial `GeolocationData` object with default values.
   */
  static getDefaultPiiLocation() {
    return {
      state: void 0,
      city: void 0
    };
  }
};
r(e, "LEAD_STORAGE_KEY", "userPiiLead"), r(e, "LOCATION_STORAGE_KEY", "userPiiLocation");
let O = e;
export {
  O as UserTransformer
};
